function parseBooleanSetting(value: string, defaultValue = true): boolean {
  const lowerValue = value.toLowerCase().trim();
  if (lowerValue === 'true') return true;
  if (lowerValue === 'false') return false;

  return defaultValue;
}

function parseLocalOverrideOrgId(value: string): number | undefined {
  if (!value || value.startsWith('#{')) return undefined;
  const n = Number.parseInt(value, 10);
  return Number.isNaN(n) ? undefined : n;
}

export const environment = {
  production: false,
  idUrl: '#{idUrl}#',
  oldApiUrl: '#{oldApiUrl}#',
  apiUrl: '#{apiUrl}#',
  angularUrl: '#{angularUrl}#',
  organisingUrl: '#{organisingUrl}#',
  blobBase: '#{blobBase}#',
  cdnBase: '#{cdnBase}#',
  loaderImg: 'SB-vertical-full-color.png',
  serverId: '#{serverId}#',
  enableClarity: parseBooleanSetting('#{enableClarity}#', true),
  enablePendo: parseBooleanSetting('#{enablePendo}#', true),
  pendoExclusionSubdomains: '#{pendoExclusionSubdomains}#',
  froalaLicenceKey: 'Ig1A7vB3A1A1B1D2D4F4I1GqgA-13kOPVi1b1b2Le2e1G1AWMSGSAFDTGHWsE7D7D6G5A1I4J4C3B6A4==',
  localOverrideOrgId: parseLocalOverrideOrgId('#{localOverrideOrgId}#'),
  paymentProviderConfigs: [
    {
      provider: 'Stripe',
      script: {
        url: 'https://js.stripe.com/v3/?advancedFraudSignals=false',
      }
    },
    {
      provider: 'BrainTree',
      script: {
        url: 'https://js.braintreegateway.com/web/dropin/1.21.0/js/dropin.min.js',
        integrityAttribute: 'sha384-sCbbwWTVvIbqipVITlKlgdBuYjpWAGiKzeZ5amZ09JrVyCNFDBTbfIGPbpVueypQ',
        crossOriginAttribute: 'anonymous',
      }
    },
    {
      provider: 'PaySafe',
      script: {
        url: 'https://hosted.paysafe.com/checkout/v1/latest/paysafe.checkout.min.js',
      }
    },
  ]
};
